// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"efc47d59","698":"3a2d7771"}[chunkId] + ".chunk.css";
};